import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useCallback, useState } from 'react';

import useLogin from '~hooks/useLogin/useLogin';
import { useStores } from '~store';
import { alert, AlertTypes } from '~types/AlertTypes';

interface SignInMagicLinkSentScreenProps {
  email: string;
}

const SignInMagicLinkSentScreen = ({ email }: SignInMagicLinkSentScreenProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { sendMagicLink } = useLogin();
  const { toasterStore } = useStores();

  const handleResendButtonClick = useCallback(async () => {
    setIsLoading(true);
    try {
      await sendMagicLink({ email });
      toasterStore.push(alert(t('actions.new_magic_link_sent'), AlertTypes.success));
    } catch {
      // Errors are handled in useLogin.
    } finally {
      setIsLoading(false);
    }
  }, [email, sendMagicLink, toasterStore]);

  return (
    <>
      <Typography
        variant="body1"
        sx={{
          textTransform: 'uppercase',
          fontWeight: 600,
        }}
      >
        {t('actions.check_your_email')}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mt: 3,
          textAlign: 'center',
        }}
      >
        {t('actions.an_email_was_sent', { email: '' })}
        <br />
        <Typography
          component="span"
          sx={{
            fontWeight: 600,
          }}
        >
          {email}
        </Typography>
      </Typography>
      <Typography
        variant="body2"
        sx={{
          mt: 10,
        }}
      >
        {t('actions.did_not_receive_it')}
      </Typography>
      <Button
        sx={{ mt: 1 }}
        fullWidth
        size="large"
        color="primary"
        variant="contained"
        onClick={handleResendButtonClick}
        loading={isLoading}
      >
        {t('actions.resend')}
      </Button>
    </>
  );
};

export default SignInMagicLinkSentScreen;
